import favouritesReducer from './favourites.slice';

export * from './favourites.slice';
export * from './favourites.thunk';

export default favouritesReducer;
